import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'

import './layout-input.scss'
import { useDebounceFn, useUpdateEffect } from 'ahooks'
import { WithInputLimit } from '@/utils'

interface LayoutInputProps {
    onBlur: (e: string) => void
    value: string
    maxNum?: number
    valueRegExp?: RegExp
    placeholder?: string
}
// 仅在失去焦点是才更新的input
const LayoutInput: React.FC<LayoutInputProps> = props => {
    const [val, setVal] = useState<string>(props.value)
    const cls = (...arg: string[]) => getBEMCls('layout-input', ...arg)

    useUpdateEffect(() => {
        setVal(props.value)
    }, [props.value])
    // 放否防止多次渲染
    const { run } = useDebounceFn(
        (e: string) => {
            props.onBlur(e)
        },
        {
            wait: 500,
        },
    )

    return WithInputLimit(
        <input
            className={cls()}
            value={val || ''}
            placeholder={props.placeholder || '请输入'}
            onChange={e => {
                setVal(e.target.value)
                run(e.target.value)
            }}
        />,
        props.valueRegExp || /^\d{0,4}(\.\d{0,3})?$/,
        props.maxNum,
    )
}

export default LayoutInput
